module.exports = __webpack_public_path__ + "media/icons/offer-details-ilosc-miejsc@3x-be9d007a.svg";